module.exports = __webpack_public_path__ + "media/images/lb/805-2354c112779f8375dda75813aa418a59.svg";